<script setup lang="ts">
const links = [{
  label: 'Horecawijs',
  children: [{
    label: 'Over ons',
    to: 'over-ons'
  }, {
    label: 'Veel gestelde vragen',
    to: '/leersysteem/getting-started'
  }, {
    label: 'Contact',
    to: '/contact'
  }]
}, {
  label: 'Online trainingen',
  children: [{
    label: 'Sociale Hygiene',
    to: '#'
  }, {
    label: 'Allergenen',
    to: '#'
  }, {
    label: 'HACCP',
    to: '#'
  }, {
    label: 'BHV',
    to: '#'
  }]
}, {
  label: 'Workshops',
  children: [{
    label: 'Whiskey',
    to: '#'
  }, {
    label: 'Bier',
    to: '#'
  }, {
    label: 'Gin',
    to: '#'
  }]
}]

const toast = useToast()

const email = ref('')
const loading = ref(false)

async function onSubmit() {
  if (!email.value) return
  loading.value = true
  console.log(email.value)
  try {
    const response = await fetch('/api/subscribe_newsletter', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email: email.value })
    })

    if (!response.ok) {
      toast.add({
        title: 'Error!',
        description: 'Er is iets misgegaan. Probeer het later opnieuw.',
        type: 'error',
      })
    }

    const result = await response.json()

    toast.add({
      title: 'Ingeschreven!',
      description: result.message || 'Je bent nu ingeschreven voor onze nieuwsbrief!'
    })
  } catch (error) {
    toast.add({
      title: 'Error!',
      description: error.message || 'Er is iets misgegaan. Probeer het later opnieuw.',
      type: 'error'
    })
  } finally {
    loading.value = false
  }
}
</script>

<template>
  <UFooter>
    <template #top>
      <UFooterColumns :links="links">
        <template #right>
          <form @submit.prevent="onSubmit">
            <UFormGroup
              label="Schrijf je in op onze nieuwsbrief"
              :ui="{ container: 'mt-3' }"
            >
              <UInput
                v-model="email"
                type="email"
                placeholder="Email adres"
                :ui="{ icon: { trailing: { pointer: '' } } }"
                required
                size="xl"
                autocomplete="off"
                class="max-w-sm"
                input-class="rounded-full"
              >
                <template #trailing>
                  <UButton
                    type="Versturen"
                    size="xs"
                    color="primary"
                    :label="loading ? 'Even geduld' : 'Inschrijven'"
                    :loading="loading"
                  />
                </template>
              </UInput>
            </UFormGroup>
          </form>
        </template>
      </UFooterColumns>
    </template>

    <template #left>
      <p class="text-gray-500 dark:text-gray-400 text-sm">
        Copyright © {{ new Date().getFullYear() }}. Horecawijs is een initiatief van <a
          href="https://www.elearn-academie.nl/"
          target="_blank"
        >Elearn-Academie</a>

      </p>
    </template>
    <template #right>
      <p class="text-gray-500 dark:text-gray-400 text-sm">
      <a href="#">Security</a> |
      <a href="#">Leveringsvoorwaarden</a> |
      <a href="#">Privacy</a> |
      <a href="#">Algemene voorwaarden</a>
      </p>
    </template>
  </UFooter>
</template>
